import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { buildEsmaStatement, COMPANY_STATEMENT_CONFIG, EsmaStatement } from '../../common/company-statement';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: []
})
export class FooterComponent {
  /** Company ESMA statement; null (hidden) while any config value is empty. Never shown beside supplier data. */
  readonly esmaStatement: EsmaStatement | null;

  constructor(translate: TranslateService) {
    this.esmaStatement = buildEsmaStatement(COMPANY_STATEMENT_CONFIG, translate.currentLang || translate.defaultLang || 'en');
  }
}
